import { render, staticRenderFns } from "./CreateWalletSoftwareOverview.vue?vue&type=template&id=387e05a2&"
import script from "./CreateWalletSoftwareOverview.vue?vue&type=script&lang=js&"
export * from "./CreateWalletSoftwareOverview.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletSoftwareOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports